import React from "react";
import __ from "lodash";
import {useQueryClient} from "react-query";
import { useCompanyContacts } from "../../../services/companies";
import { makeStyles } from "@material-ui/core";
import { LightTooltip } from "../..";
import TripToolTipStyles from "../TripToolTipStyles";
import CompanyUuidLookup from "../../../modules/Companies/components/CompanyUuidLookup";

const SupplierName = (props) => {
  const {companyUuid, airportCode, companyType, role} = props;
  const queryClient = useQueryClient();
  const classes = makeStyles(TripToolTipStyles)();

  const companyContacts = useCompanyContacts({queryClient, extraKeys: [companyUuid], useCache: true});
  let contactDetails = undefined;
  if (companyContacts && Array.isArray(companyContacts.data) && companyContacts.data.length > 0) {
    const airportContacts = role?__.find(companyContacts.data, {airportCode, role}):__.find(companyContacts.data, {airportCode});
    if (airportContacts && Array.isArray(airportContacts.contactMethods) && airportContacts.contactMethods.length > 0 ) {
      contactDetails = (
        <div>
          {airportContacts.contactMethods.map(contact => {
            return Object.entries(contact).map(([type, value]) => {
              return (
                <div className={classes.contactRow}>
                  <div style={{display: "inline-block"}}>
                    {type}:
                  </div>
                  <div style={{display: "inline-block"}}>
                    {type==="email"?
                      <a href={`mailto:${value}`}>{value}</a>
                    : type==="phone"?
                      <a href={`tel:${value}`}>{value}</a>
                    :
                      <span>{value}</span>
                    }
                  </div>
                </div>
              )
            })
          })}
        </div>
      )
    }
  }

  if (contactDetails) {
    return (
      <LightTooltip 
        arrow 
        interactive
        title={contactDetails}
        leaveDelay={200}
      >
        <div>
          <CompanyUuidLookup
            companyType={companyType}
            value={companyUuid}
            atAirport={companyType==='FUEL_SUPPLIER'?airportCode:undefined}
            type="render"
            hideCode={true}
          />
        </div>
      </LightTooltip>  
    )
  }

  return (
    <CompanyUuidLookup
      companyType={companyType}
      value={companyUuid}
      atAirport={companyType==='FUEL_SUPPLIER'?airportCode:undefined}
      type="render"
      hideCode={true}
    />
  )
}

export default SupplierName;